import * as React from "react";

import type { DesignaliProps } from "../../types";

export const CircleParking = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M2 12a10 10 0 1 1 10 10" />
        <path d="m2 22 10-10" />
        <path d="M8 22H2v-6" />
      </svg>
    );
  },
);

export default CircleParking;
